module.exports = __webpack_public_path__ + "media/images/flags/sh-64fc84e6ed5eced1e97ce9830c1b2380.svg";